import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, defineComponent } from 'vue'
const _hoisted_1 = {
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  'enable-background': 'new 0 0 512 512',
  'xml:space': 'preserve'
}
const _hoisted_2 = /*#__PURE__*/ _createElementVNode(
  'g',
  null,
  [
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M457.6,140.2l-82.5-4l-4.8-53.8c-1-11.3-11.1-19.2-22.9-18.3L51.5,88.4c-11.8,1-20.3,10.5-19.4,21.7l21.2,235.8\r\n\t\tc1,11.3,11.2,19.2,22.9,18.3l15-1.2l-2.4,45.8c-0.6,12.6,9.2,22.8,22.4,23.5L441.3,448c13.2,0.6,24.1-8.6,24.8-21.2L480,163.5\r\n\t\tC480.6,151,470.7,140.8,457.6,140.2z M102.7,145.5l-7.1,134.8L78.1,305L62,127c0-0.2,0-0.3,0-0.5s0-0.3,0-0.5c1-5,4.4-9,9.6-9.4\r\n\t\tl261-21.4c5.2-0.4,9.7,3,10.5,7.9c0,0.2,0.3,0.2,0.3,0.4c0,0.1,0.3,0.2,0.3,0.4l2.7,30.8l-219-10.5\r\n\t\tC114.2,123.8,103.3,133,102.7,145.5z M436.7,382.4l-84.8-99.5l-37.4,34.3l-69.2-80.8L122.6,367.1L133,168c0,0,0-0.3,0-0.4\r\n\t\tc1-5.4,6.2-9.3,11.9-9l291.2,14c5.8,0.3,10.3,4.7,10.4,10.2c0,0.2,0.3,0.3,0.3,0.5L436.7,382.4z'
    }),
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M384,256c17.6,0,32-14.4,32-32s-14.3-32-32-32c-17.6,0-32,14.3-32,32S366.3,256,384,256z'
    })
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
export default defineComponent({
  name: 'MdImages',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_3)
  }
})
